import { captureExceptionWithTags } from 'src/utils/sentry';

import { PIPELINES_SENTRY_PRIMARY_TAG } from '../constants';

const SKIP_FLAG = '__skip__';

export const createErrorMessage = (
  res: Response,
  statusToSkip: number[] = []
): string => {
  return statusToSkip.includes(res.status)
    ? SKIP_FLAG
    : `${res.status}: ${res.statusText}`;
};

/**
 * This function wraps `captureExceptionWithTags` with a preset tag - app:pipelines.
 * @param tags - Object, optional
 * @param extras - Object, optional
 * @returns - void
 */
export const capturePipelinesExceptionWithTags = (
  e: Maybe<Error>,
  tags?: { [key: string]: string },
  extras?: { [key: string]: string }
): void => {
  if (e?.message?.toLowerCase() === SKIP_FLAG) {
    return;
  }
  const mergedTags = {
    ...tags,
    app: PIPELINES_SENTRY_PRIMARY_TAG,
  };
  captureExceptionWithTags(e!, mergedTags, extras);
};

export const isIgnoredErrorForSentry = (
  e: Maybe<Error>,
  messagesToSkip: string[] = []
): boolean => {
  const skipMessages = ['resource not found', 'not found', ...messagesToSkip];
  if (!e?.message) return false;
  return skipMessages.includes(e.message.toLowerCase());
};
